import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

const API_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_URL,
});

// Interceptor para agregar token en headers
api.interceptors.request.use(
  (config) => {
    const token = secureStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const PostDatosProductosTejidos = async (datos) => {
  try {
    const response = await api.post('productosTejidos', datos);
    return response.data;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

const getProductosTejidos = async () => {
  try {
    const response = await api.get('productosTejidos'); // asegúrate que esta ruta existe en tu backend
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
};


export {
  PostDatosProductosTejidos, getProductosTejidos
};